module.exports = __webpack_public_path__ + "static/media/avatar.06bd3f7d.svg";